import { useState, useContext, useEffect, useMemo } from "react";
import { read, utils } from "xlsx";
import { TimetablesContext } from "../../contexts/timetablesContext";

export const ReadExcel = () => {
  const { data, loading } = useContext(TimetablesContext);
  const timetables = !loading && data && data.allTimetable;

  const [todaysData, setTodaysData] = useState({});
  const [pdfURL, setPdfURL] = useState('');
  const [jummahTimes, setJummahTimes] = useState([]);

  const { dayOfMonth, timetableName, gregorianDate, hijriDate } = useMemo(() => {
    const today = new Date();
    return {
      dayOfMonth: String(today.getDate()),
      timetableName: new Intl.DateTimeFormat("en-UK", {
        month: "long",
        year: "numeric"
      }).format(today),
      gregorianDate: new Intl.DateTimeFormat("en-UK", {
        day: "numeric",
        month: "long",
        year: "numeric"
      }).format(today),
      hijriDate: new Intl.DateTimeFormat("en-UK", {
        calendar: 'islamicc',
        day: "numeric",
        month: "long",
        year: "numeric"
      }).format(today)
    };
  }, []);

  useEffect(() => {
    if (timetables) {
      const result = timetables.find((obj) => obj.title === timetableName);
      if (!result) return;

      const url = result.excel_file.asset.url;
      setJummahTimes([result.jummah_1, result.jummah_2, result.jummah_3]);
      setPdfURL(result.pdf_file.asset.url);

      const req = new XMLHttpRequest();
      req.open("GET", url, true);
      req.responseType = "arraybuffer";

      req.onload = function () {
        const data = new Uint8Array(req.response);
        const wb = read(data, { type: "array" });
        const ws = wb.Sheets["Sheet1"];
        const datas = utils.sheet_to_json(ws, { raw: false });
        setTodaysData(datas[parseInt(dayOfMonth) - 1]);
      };
      req.send();
    }
  }, [timetables, timetableName, dayOfMonth]);

  return (
    <div className="mainCallToAction">
      <div className="date-wrapper mceNonEditable">
        <a target="_blank" rel="noreferrer noopener" href={pdfURL}>
          Download Timetable
        </a>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <div className="gregorian">{gregorianDate}</div>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <div className="hijri">{hijriDate}</div>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
        <div className="jummah">Jummah</div>
        <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
      </div>
      <div className="salah-block-content mceNonEditable">
        <div className="salah-times">
          <div className="salah-time-row">
            <span className="col2"></span>
            <span className="col3 col-s">Fajr</span>
            <span className="col4 col-s">Zuhr</span>
            <span className="col5 col-s">'Asr</span>
            <span className="col6 col-s">Maghrib</span>
            <span className="col7 col-s">'Ishā</span>
            <span className="col7 col-s" />
            <span className="col7 col-s">1st</span>
            <span className="col7 col-s">{jummahTimes[0]}</span>
          </div>
          <div className="salah-time-row time-start">
            <span className="col2">Begins</span>
            <span className="col3 col-s fajr">{todaysData['Fajr Start']}</span>
            <span className="col4 col-s zuhr">{todaysData['Zuhr Start']}</span>
            <span className="col5 col-s asr">{todaysData['Asr Start']}</span>
            <span className="col6 col-s maghrib">{todaysData['Magrib']}</span>
            <span className="col7 col-s isha">{todaysData['Isha Start']}</span>
            <span className="col7 col-s" />
            <span className="col7 col-s">2nd</span>
            <span className="col7 col-s">{jummahTimes[1]}</span>
          </div>
          <div className="salah-time-row time-end">
            <span className="col2">Jamā'ah</span>
            <span className="col3 col-s fajr">{todaysData['Fajr Jamaat']}</span>
            <span className="col4 col-s zuhr">{todaysData['Zuhr Jamaat']}</span>
            <span className="col5 col-s asr">{todaysData['Asr Jamaat']}</span>
            <span className="col6 col-s maghrib">{todaysData['Magrib']}</span>
            <span className="col7 col-s isha">{todaysData['Isha Jamaat']}</span>
            <span className="col7 col-s" />
            <span className="col7 col-s">Girls Sch</span>
            <span className="col7 col-s">{jummahTimes[2]}</span>
          </div>
        </div>
      </div>
    </div>
  );
};
